<template>
<!-- 直播开通审核 -->
<section>
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <el-collapse-transition>
    <div v-show="show3">
      <el-form :inline="true" class="findform">
        <!-- 顶部搜索框 -->
        <el-form-item label="手机号：" style="display:flex;width:25%">
          <el-input v-model="partnerPhone" placeholder="请输入手机号" maxlength="11" style="width:90%;"/>
        </el-form-item>
        <el-form-item label="身　　份：" style="display:flex;width:25%;">
          <el-select v-model="partnerGender" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in identityArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item label="状　　态：" style="display:flex;width:25%;">
          <el-select v-model="partnerRegion" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in auditStatusArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="findform">
        <el-form-item label="城市：" style="display:flex;width:25%;">
          <el-cascader v-model="chengshi" placeholder="请选择城市" :options="options"
          filterable clearable @change="handleChange" style="width: 90%"/>
        </el-form-item>
        <el-form-item label="店铺名称：" style="display:flex;width:25%">
          <el-input v-model="storeName" placeholder="请输入店铺名称" maxlength="20" style="width: 90%;"/>
        </el-form-item>
        <el-form-item label="房间号码：" style="display:flex;width:25%">
          <el-input v-model="roomNumber" placeholder="请输入房间号码" maxlength="11" style="width: 90%;"/>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">直播开通审核列表</p>
      <el-button type="danger" @click="endDeletegood()" style="float: right;margin: 5px 10px 0 0;">批量删除</el-button>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="liveList" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center"/>
        <el-table-column label="序号" align="center" width="50px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="申请时间" align="center">
          <template scope="scope">{{scope.row.applyTime}}</template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
        <el-table-column label="姓名" align="center">
          <template scope="scope">{{scope.row.name}}</template>
        </el-table-column>
        <el-table-column label="微信号" align="center">
          <template scope="scope">{{scope.row.wxCode}}</template>
        </el-table-column>
        <el-table-column label="开播内容" align="center">
          <template scope="scope">{{scope.row.liveConent}}</template>
        </el-table-column>
        <el-table-column label="开播时间" align="center">
          <template scope="scope">{{scope.row.liveTime}}</template>
        </el-table-column>
        <el-table-column label="身份" align="center">
          <template scope="scope">{{scope.row.userIdentityName}}</template>
        </el-table-column>
        <el-table-column label="所属城市" align="center">
          <template scope="scope">{{scope.row.cityName}}</template>
        </el-table-column>
        <el-table-column label="关联店铺" align="center">
          <template scope="scope">{{scope.row.shopName}}</template>
        </el-table-column>
        <el-table-column label="房间号码" align="center">
          <template scope="scope">{{scope.row.roomId}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">{{scope.row.stateName}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="handleSh(scope.row, 1)" class="handle" v-if="scope.row.state == 1"> 开通 </span>
            <span @click="handleSh(scope.row, 2)" class="handle" v-if="scope.row.state == 2"> 编辑关联 </span>
            <span @click="adoptToExamine(scope.row)" class="handle" v-if="scope.row.state == 1"> 拒绝 </span>
            <span @click="endDeletegood(scope.row)" class="handle" v-if="scope.row.state == 3"> 删除 </span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <!-- 直播开通审核 & 编辑关联 -->
  <el-dialog :title="auditAssociation" :center="true" class="add_order_cancle" width="35%" :visible.sync="zbktshBjgl">
    <el-form :inline="true" label-width="200px">
      <el-form-item label="所属城市：" style="display:flex;">
        <el-cascader v-model="sscs" placeholder="请选择城市" :options="suoshuchengshi"
        style="width: 100%" filterable clearable @change="handleCity"/>
      </el-form-item>
      <el-form-item label="关联店铺（选填）：" style="display:flex;">
        <el-select v-model="gldp" filterable placeholder="请选择店铺">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
      <el-form-item :label="auditAssociation=='直播开通审核'?'房间号码：':'房间号码（选填）：'" style="display:flex;">
        <el-input v-model="fjhm" placeholder="请输入直播房间号" maxlength="11"/>
      </el-form-item>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <el-button @click="zbktshBjgl = false">取 消</el-button>
      <el-button type="danger" @click="determine()">确定</el-button>
    </div>
  </el-dialog>

  <!-- 拒绝-弹框 -->
  <el-dialog title="直播开通审核" :center="true" class="add_order_cancle" width="30%" :visible.sync="isToExamine">
    <el-form>
      <el-form-item>
        <el-input type="textarea" placeholder="请输入审核备注" maxlength="200" v-model="shenmark" :rows="3"/>
      </el-form-item>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <el-button type="danger" @click="endToExamine(3)">拒绝</el-button>
      <el-button @click="isToExamine = false">取 消</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import { userIdentity } from '../../api/newOss';
import { getProvinceAndCityAndZoneByDataType } from "../../api/api";
import { getAppliedLive, putReviewApplication, mpbroadcastEdit, getRelation, putRejectLive, deleteMpbroadcast } from "../../api/shopWindow";
export default {
  name: 'liveBroadcastOpeningAudit',
  data() {
    return {
      show3: true, // 查询区域默认展开
      broadcastId: "", // id
      broadcastPhone: "", // 手机号
      batchliveListArr:[], // 复选框选中项
      liveList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      partnerPhone: "", // 手机号
      partnerGender: 0, // 身份
      partnerRegion: 0, // 状态
      chengshi: "", // 城市
      storeName: "", // 店铺名称
      roomNumber: "", // 房间号码
      options: [],
      provinceId: 0, // 省id
      cityId: 0, // 市id
      identityArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "普通用户"
        },
        {
          Id: 2,
          Name: "甄惠装会员"
        },
        {
          Id: 3,
          Name: "商家"
        },
        {
          Id: 4,
          Name: "平台"
        },
        {
          Id: 5,
          Name: "工长"
        },
        {
          Id: 6,
          Name: "设计师"
        }
      ],
      auditStatusArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "审核中"
        },
        {
          Id: 2,
          Name: "已通过"
        },
        {
          Id: 3,
          Name: "未通过"
        }
      ],

      auditAssociation: '直播开通审核', // 直播开通审核 & 编辑关联
      zbktshBjgl: false, // 直播开通审核 & 编辑关联
      sscs: '', // 所属城市
      suoshuchengshi: [],
      ssshengId: -1, // 省
      ssshiId: -1, // 市
      options1: [],
      gldp: '', // 关联店铺
      fjhm: '', // 房间号码
      
      isToExamine: false, // 审核弹框
      shenmark: "", // 审核意见
    }
  },
  methods: {
    // 查询列表
    getInit() {
      let addParams = {
        phone: this.partnerPhone, // 手机号
        userIdentity: this.partnerGender, // 主播身份类型：0=全部，1=普通用户；2=黑金卡会员；3=商家；4=平台；5=工长；6=设计师
        state: this.partnerRegion, // 审核状态，0=全部，1=审核中；2=未通过；3=已通过
        ProvinceId: this.provinceId, // 省id
        CityId: this.cityId, // 市id
        ShopName: this.storeName, // 店铺名称
        RoomId: this.roomNumber, // 房间号码
        pageIndex: this.pageIndex,// 页码
        pageSize: this.pageSize // 每页行数
      };
      getAppliedLive(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.liveList = data.resultObj.resultObj;
            this.totalRowsCount = data.resultObj.rowsCount;
          } else {
            this.liveList = [];
            this.totalRowsCount = 0;
          }
        } else {
          this.liveList = [];
          this.totalRowsCount = 0;
        }
      })
    },
    // 开通 & 编辑关联 按钮
    handleSh(row, val) {
      this.broadcastId = row.id; // 直播id
      this.auditAssociation = val==1?'直播开通审核':'编辑关联'; // 直播开通审核 & 编辑关联
      this.zbktshBjgl = true; // 审核弹框展示
      if(val==1) {
        this.sscs = '', // 清空所属城市
        this.ssshengId = 0,
        this.ssshiId = 0,
        this.gldp = ''; // 清空关联店铺
        this.fjhm = ''; // 清空房间号码
      } else {
        this.tankuang(); // 关联店铺
        var addParams = {
          id: this.broadcastId, // 申请记录id，随列表返回
        };
        getRelation(addParams).then(data => {
          if(data.resultCode == 1) {
            let thisObj = data.resultObj;
            this.broadcastId = thisObj.id; // 记录id
            // this.state = thisObj.state // 状态
            this.sscs = [thisObj.provinceId,thisObj.cityId]
            this.ssshengId = thisObj.provinceId // 省份id
            this.ssshiId = thisObj.cityId // 城市id
            this.gldp = thisObj.bbId // 关联店铺
            this.fjhm = thisObj.roomId?thisObj.roomId:'' // 房间号
          } else {
            this.$swal({
              type: "warning",
              text: data.resultMsg,
            });
          }
        })
      }
    },
    // 确定
    determine() {
      if(this.sscs == '') {
        this.$swal({
          type:"warning",
          text:"请选择所属城市"
        })
        return false;
      }
      if(this.auditAssociation=='直播开通审核') {
        if(this.fjhm == '') {
          this.$swal({
            type:"warning",
            text:"请输入房间号码"
          })
          return false;
        }
        var addParams = {
          id: this.broadcastId, // 申请记录id，随列表返回
          state: 2, // 审核状态 2=通过、3=拒绝
          provinceId: this.ssshengId, // 省份id
          cityId: this.ssshiId, // 城市id
          bbId: this.gldp, // 店铺id（可空）
          roomId: this.fjhm, // 房间号
          reviewer: localStorage.Id, // 审核人id
        };
        putReviewApplication(addParams).then(data => {
          if(data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: data.resultMsg,
            });
            this.zbktshBjgl = false;
            this.getInit();
          } else {
            this.$swal({
              type: "warning",
              text: data.resultMsg,
            });
          }
        })
      } else { // 编辑关联
        var addParams = {
          id: this.broadcastId, // 申请记录id，随列表返回
          state: 2, // 审核状态（此接口写死为2）
          provinceId: this.ssshengId, // 省份id
          cityId: this.ssshiId, // 城市id
          bbId: this.gldp, // 店铺id（可空）
          roomId: this.fjhm, // 房间号（可空）
          reviewer: localStorage.Id, // 审核人id
        };
        mpbroadcastEdit(addParams).then(data => {
          if(data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: data.resultMsg,
            });
            this.zbktshBjgl = false;
            this.getInit();
          } else {
            this.$swal({
              type: "warning",
              text: data.resultMsg,
            });
          }
        })
      }
    },
    // 拒绝按钮
    adoptToExamine(row) {
      this.broadcastId = row.id; // 直播id
      this.broadcastPhone = row.phone; // 手机号
      this.shenmark = ""; // 清空备注
      this.isToExamine = true; // 审核弹框展示
    },
    // 审核拒绝
    endToExamine(stateVal) {
      if (this.shenmark == "") {
        this.$swal({
          type:"warning",
          text:"请输入审核备注"
        })
        return false;
      }
      var addParams = {
        id: this.broadcastId, // 申请记录id，随列表返回
        remark: this.shenmark, // 审核意见
        reviewer: localStorage.Id, // 审核人id
      };
      putRejectLive(addParams).then(data => {
        if(data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: data.resultMsg,
          });
          this.isToExamine = false;
          this.getInit();
        } else {
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          });
        }
      })
    },
    // 批量删除
    endDeletegood(row){
      if(!row && this.batchliveListArr.length == 0){
        this.$swal({
          text:"请选择需要删除的数据 !",
          type:"warning"
        })
        return false;
      }
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = row?[row.id]:this.batchliveListArr
          deleteMpbroadcast(obj).then(data=>{
            if(data.resultCode == 1){
              this.$swal({
                type:"success",
                text: data.resultMsg
              })
              this.getInit();
            }
          })
        }
      })
    },
    // 复选框
    handleSelectionChange(val) {
      this.batchliveListArr = [];
      val.forEach(element => {
        this.batchliveListArr.push(element.id);
      });
    },
    // 重置
    fnReset() {
      this.partnerPhone = ""; // 手机号
      this.partnerGender = 0; // 身份
      this.partnerRegion = 0; // 状态
      this.chengshi = ""; // 城市
      this.provinceId = 0; // 省
      this.cityId = 0; // 市
      this.storeName = ""; // 店铺名称
      this.roomNumber = ""; // 房间号码
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getInit();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
    // 请选择店铺
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
        provinceId: this.ssshengId, // 省份id
        cityId: this.ssshiId, // 城市id
      };
      userIdentity(addParams).then(data => {
        if (data.resultCode == 1) {
          this.options1 = data.resultObj;
          this.options1.unshift({
            id: 0,
            name: "无",
          });
        }
      })
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    // 查找省市
    getprovince() {
      var loginParams = {
        isOpen: 0,
        dataLevel: 2,
      };
      getProvinceAndCityAndZoneByDataType(loginParams).then((data) => {
        let that = this;
        let cityList = [];
        data.ResultObj.map((item) => {
          let cityData = { value: item.Id, label: item.Name, children: [] };
          cityList.push(cityData);
          item.CityList.map((city) => {
            cityData.children.push({ value: city.Id, label: city.Name });
          });
        });
        that.options = JSON.parse(JSON.stringify(cityList));
        that.options.map(item => {
          if(item.children.length > 1){
            item.children.unshift({ value: -1, label: '全部' });
          }
        })
        that.options.unshift({ value: 0, label: '全国' });
        that.suoshuchengshi = cityList;
      })
    },
    // 所属城市
    handleCity(val) {
      this.ssshengId = val[0];
      this.ssshiId = val[1];
      this.gldp = '';
      this.tankuang(); // 关联店铺
    },
  },
  created() {
    this.getInit(); // 查询列表
    this.getprovince(); // 城市
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// liveBroadcastOpeningAudit.vue?2970e53d